import FreeAccessPrompt from '@/components/FreeAccessPrompt.tsx'
import { Drawer, DrawerContent } from '@/components/shadcn/drawer.tsx'
import { ScrollArea } from '@/components/shadcn/scroll-area.tsx'
import { LandingFeedProps } from '@/components/templates/LandingAdCard'
import { trpc } from '@/utils/trpc.ts'
import { X } from '@mynaui/icons-react'
import { useState } from 'react'
import LanderInspirationDetailsBody from './LanderInspirationDetailsBody'
import { LanderInspirationDetailsMedia } from './LanderInspirationDetailsMedia'
import { Loader } from './custom-components/Loader'

export default function LanderAdInspirationDetails({
  open,
  onOpenChange,
  data,
  IsPublic,
}: {
  open: boolean
  onOpenChange: () => void
  data: LandingFeedProps
  IsPublic: boolean
}) {
  const [accessPromptDialogOpen, setAccessPromptDialogOpen] = useState<boolean>(false)
  const [saveOpen, setSaveOpen] = useState<boolean>(false)

  const { data: landerAdDetails, isLoading } = trpc.getLander.useQuery(
    {
      landerId: data.landerId ?? 0,
    },
    {
      refetchOnMount: true,
    },
  )

  const { data: numberOfActiveAdsForBrand } = trpc.getNumberOfActiveAdsForBrand.useQuery(
    { brandId: data.brandId || '' },
    {
      enabled: open,
    },
  )

  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      {accessPromptDialogOpen && (
        <FreeAccessPrompt open={accessPromptDialogOpen} onOpenChange={() => setAccessPromptDialogOpen(false)} />
      )}

      {isLoading ? (
        <DrawerContent className={'h-[90vh] w-full min-h-[90vh] max-h-[90vh]'}>
          <div className="flex flex-col justify-center items-center w-full h-[90vh] min-h-[90vh] max-h-[90vh]">
            <Loader />
          </div>
        </DrawerContent>
      ) : (
        <DrawerContent
          className={'h-[90vh] p-1 flex flex-col-reverse lg:flex-row w-full'}
          onInteractOutside={saveOpen ? (e) => e.preventDefault() : undefined}
        >
          <ScrollArea className={'bg-themeaccent dark:bg-themeaccentdark rounded h-full w-full hidden lg:flex'}>
            <LanderInspirationDetailsMedia
              data={landerAdDetails ?? data}
              saveOpen={saveOpen}
              setSaveOpen={setSaveOpen}
              IsPublic={IsPublic}
              numberOfActiveAdsForBrand={numberOfActiveAdsForBrand}
            />
          </ScrollArea>
          <div className="hidden lg:flex">
            <div className="flex flex-col rounded lg:h-full w-full lg:w-[28rem]">
              <div className={'flex justify-end h-4 min-h-4'}>
                <span onClick={onOpenChange} className={'p-1 cursor-pointer'}>
                  <X className="w-4 h-4 min-w-4" />
                </span>
              </div>

              <ScrollArea className="h-full">
                <LanderInspirationDetailsBody data={data} />
              </ScrollArea>
            </div>
          </div>
          <ScrollArea className="flex lg:hidden h-full">
            <div className="flex flex-col rounded lg:h-full w-full lg:max-w-[28rem]">
              <div className={'flex justify-end h-4 min-h-4'}>
                <span onClick={onOpenChange} className={'p-1 cursor-pointer'}>
                  <X className="w-4 h-4 min-w-4" />
                </span>
              </div>

              <LanderInspirationDetailsBody
                data={data}
                mediaComponent={
                  <ScrollArea
                    className={'bg-themeaccent dark:bg-themeaccentdark rounded h-full w-full lg:min-h-[65vh]'}
                  >
                    <LanderInspirationDetailsMedia
                      data={landerAdDetails ?? data}
                      saveOpen={saveOpen}
                      setSaveOpen={setSaveOpen}
                      IsPublic={IsPublic}
                      numberOfActiveAdsForBrand={numberOfActiveAdsForBrand}
                    />
                  </ScrollArea>
                }
              />
            </div>
          </ScrollArea>
        </DrawerContent>
      )}
    </Drawer>
  )
}
